exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#child-policy .row {\n\tpadding-bottom: 4px;\n}\n", ""]);

// exports
